import{b as e}from"./chunk-Z2X7BHA2.js";import{e as r,m as o}from"./chunk-HBP5N4FR.js";var f=r(()=>{o();e()});export{f as a};
//# sourceMappingURL=chunk-PEVVU2AQ.js.map
